import { getZIndex } from '@components/services/zIndex'
import maskManager from '@components/services/maskManager'

export default {
  props: {
    show: {
      type: Boolean,
      required: false,
      default: true
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    modal: {
      type: Boolean,
      required: false,
      default: true
    },
    closeOnModalClick: {
      type: Boolean,
      required: false,
      default: true
    },
    modalOpacity: {
      type: Number,
      required: false
    },
    modalColor: {
      type: String,
      required: false
    },
    modalClassname: {
      type: String,
      required: false,
      default: ''
    },
    zIndex: {
      type: Number,
      required: false
    },
    closable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    let mask = null
    if (this.modal) {
      mask = maskManager.create({
        opacity: this.modalOpacity,
        color: this.modalColor,
        classname: this.modalClassname,
        onClick: this.onModalClick,
        zIndex: this.zIndex
      }, this)
    }
    let actualZIndex = Number(this.zIndex) + 1
    if (!this.zIndex) {
      actualZIndex = getZIndex()
    }
    return {
      mask: mask,
      actualZIndex: actualZIndex,
      iShow: this.show
    }
  },
  watch: {
    show: {
      handler: function(val) {
        this.iShow = val
      },
      immediate: true
    },
    iShow: {
      handler: function(val) {
        if (val) {
          maskManager.show(this.mask)
        } else {
          maskManager.hide(this.mask)
        }
        this.$emit('update:show', val)
      },
      immediate: true
    },
  },
  beforeDestroy() {
    maskManager.destroy(this.mask)
  },
  methods: {
    close() {
      if (!this.closable) {
        return
      }
      this.iShow = false
      this.$emit('close')
    },
    onModalClick() {
      // noop
    },
    onTouchStart(e) {
      this.touchY = e.touches[0].clientY
      e.stopPropagation()
    },
    handleScroll(e) {
      this.recordTouch(e)
      let direction = 'down'
      if (this.touchY < this.previousTouchY) {
        direction = 'up'
      }
      if (isClick(this.previousTouchY, this.touchY)) {
        return
      }
      const scrollTop = this.$refs.content.scrollTop
      const maxScrollTop = this.$refs.content.scrollHeight - this.$refs.content.clientHeight
      if (e.cancelable) {
        if (direction === 'up' && scrollTop >= maxScrollTop) {
          e.preventDefault()
        }
        if (direction === 'down' && scrollTop <= 0) {
          e.preventDefault()
        }
      }
      e.stopPropagation()
      if (e.type === 'touchend') {
        this.previousTouchY = null
      }
    },
    recordTouch(e) {
      if (e.type !== 'touchend') {
        this.previousTouchY = this.touchY
      }
      if (e.touches[0]) {
        this.touchY = e.touches[0].clientY
      }
    }
  }
}

function isClick(previousY, currentY) {
  if (previousY === null || typeof previousY === 'undefined') {
    return true
  }
  if (Math.abs(currentY - previousY) < 3) {
    return true
  }
  return false
}
